<!--start-jewellery-product-->
<div class="section-jewellery">
    <div class="container">
        <div class="content-top">
            <input type="text">
            <i class="fas fa-search fa-1x"></i>
        </div>
        <div class="row">
            <div class="col-lg-3 col-sm-6" *ngFor='let Seller of bestSeller'>
                <div class="sellerone">
                    <div class="content">
                        <img [src]='Seller.src'>
                        <div class="sellertwo">
                            <i class="fas fa-shopping-cart"></i>
                            <i class="fas fa-heart"></i>
                            <i class="fas fa-allergies" routerLink="infoProduct"></i>
                        </div>
    
                    </div>
                    <p class="bottom-p-one"> {{Seller.text}}</p>
                    <p class="bottom-p-two"> {{Seller.price}}</p>
                    <ngb-rating class="rate" [rate]='Seller.rate'></ngb-rating>
                </div>
    
        </div>
        <ngb-pagination class="pagination" [collectionSize]="collectionSize" [(page)]="page" aria-label="Default pagination"></ngb-pagination>

    </div>
   
</div>